<template>
	<div class="container">
		<!--页面开始-->
		<div class="step_box">
			<div class="step_el" style="padding: 0.45rem;">
				<div class="note_el">
					<div class="title">1) 测试的已知和潜在风险和好处是什么？</div>
					<div class="title_l">潜在风险包括：</div>
					<div class="text">a) 样本采集过程中可能出现的不适。</div>
					<div class="text">b) 可能不正确的测试结果（更多信息参见警告和结果解释部分）。</div>
					<div class="title_l">潜在的好处包括：</div>
					<div class="text">a) 检测结果及相关信息可以帮助您和您的医疗保健提供者就您的护理提出明智的建议。</div>
					<div class="text">b) 该测试的结果可能有助于限制 COVID-19 向您的家人和社区其他人的潜在传播。 </div>
					<div class="text">
						有关 EUA 的更多信息，请访问此处：<a style="color: #0073DE;"
							href="https://www.fda.gov/emergency-preparedness-and-response/mcm-legal-regulatory-and-policy-framework/emergency-use-authorization">https://www.fda.gov/emergency-preparedness-and-response/mcm-legal-regulatory-and-policy-framework/emergency-use-authorization</a>
					</div>
				</div>
				<div class="note_el">
					<div class="title">2) 抗原检测和分子检测有何区别？</div>
					<div class="text">
						有多种方法可以检测新型冠状病毒。分子测试检测病毒的遗传物质。抗原测试，例如 CorDx COVID-19 Ag Test，可检测病毒中的蛋白质。由于抗原检测的灵敏度较低，因此当您感染新型冠状病毒时，与分子检测相比，该检测给您假阴性结果的可能性更高。
					</div>
				</div>
				<div class="note_el">
					<div class="title">3) 这个产品有多准确？</div>
					<div class="text">
						临床研究表明，在几天内多次进行抗原检测可以更准确地确定您是否感染了新型冠状病毒。重复测试可提高测试准确性。建议采用这种连续测试方法，以最大限度地降低错误结果的风险。有关产品性能以及性能如何适用于您的更多信息，请参阅医疗保健提供者使用说明 (IFU) 中的性能数据
						<div>
							<a style="color: #0073DE;"
								href="https://www.fda.gov/medical-devices/coronavirus-disease-2019-covid-19-emergency-use-authorizations-medical-devices/in-vitro-diagnostics-euas-antigen-diagnostic-tests-sars-cov-2">https://www.fda.gov/medical-devices/coronavirus-disease-2019-covid-19-emergency-use-authorizations-medical-devices/in-vitro-diagnostics-euas-antigen-diagnostic-tests-sars-cov-2</a>
						</div>
					</div>
				</div>
				<div class="note_el">
					<div class="title">4) 如果我的测试结果呈阳性怎么办？</div>
					<div class="text">
						阳性结果意味着您很可能感染了新型冠状病毒，因为在您的样本中发现了新型冠状病毒的蛋白质。您应该自我隔离，并联系医疗保健提供者以获取有关您的阳性结果的医疗建议。
					</div>
				</div>
				<div class="note_el">
					<div class="title">5) 如果我的检测结果为阴性怎么办？</div>
					<div class="text">
						阴性测试结果表明在您的样本中未检测到新型冠状病毒的抗原。但是，如果您有新冠的症状，并且您的第一次检测呈阴性，您应该在 48 小时后再次检测，因为抗原检测不如分子检测灵敏。如果您没有症状并且得到阴性结果，您应该至少再测试两次，两次测试之间间隔 48 小时，总共进行三次测试。如果结果为阴性，仍不能排除新型冠状病毒感染；您仍可能会被感染，并且您仍可能会感染其他人。您应向您的医疗保健提供者了解您应该采取的后续步骤，这非常重要。
					</div>
				</div>
				<div class="note_el">
					<div class="title">6) 无效的测试结果意味着什么？</div>
					<div class="text">
						无效结果意味着测试无法判断您是否患有新冠。如果测试无效，应使用新的拭子采集新的鼻腔样本，并用新的检测卡进行再次测试。
					</div>
				</div>
			</div>
			<div class="btn_box">
				<van-button type="primary" block round color="linear-gradient(to right, #a74af2, #5949f2)"
					@click="goStepOne">
					完成
				</van-button>
			</div>
			<!--页面开始-->
		</div>
	</div>
</template>

<script>
	import {
		ImagePreview
	} from "vant";
	export default {
		components: {
			//
		},
		data() {
			return {
				//
			}
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#fbfbfb;');
		},
		created() {
			// this.$toast.loading({
			// 	duration: 0,
			// });
		},
		mounted() {
			//this.$toast.clear();
		},
		watch: {
			//
		},
		methods: {
			//跳转步骤1
			goStepOne() {
				//this.$router.push({ path: '/chinese/stepOne' });
				this.$router.push({ path: '/scanqrcode' });
			},
			//展示大图
			showBig(value) {
				let that = this;
				ImagePreview({
					images: that.imgList,
				});
			}
		},
		destroyed() {
			//
		}
	}
</script>
</script>

<style scoped>
	.container {
		/* position: absolute;
	height: 100%; */
		/* background-color: #fbfbfb; */
	}

	.top_tip {
		padding: 0.25rem 0.45rem;
		background-color: #ffcaca;
		font-size: 0.32rem;
		color: #720000;
		border-radius: 8px;
		border: 1px #720000 solid;
		font-weight: bold;
	}

	.step_box .step_el {
		background-color: #ffffff;
		margin-bottom: 0.32rem;
		border-radius: 0.32rem;
		box-shadow: 0 0 0.4rem rgb(0, 0, 0, 0.1);
		overflow: hidden;
		position: relative;
		border: 1px solid #E9E9E9;
	}

	.step_box .step_el:last-child {
		margin-bottom: 0;
	}

	/* .step_box, .btn_box{background-color: #fbfbfb;} */
	.step_box {
		padding-bottom: 0.64rem !important;
	}

	/*步骤下说明文字*/
	.step_txt {
		padding: 0.533rem 0.64rem 0.427rem 0.64rem;
		color: #333333;
	}


	.countdown_box {
		padding: 0.2rem 0.5rem 0.3rem 0.5rem;
		text-align: center;
		color: #666666;
	}

	.countdown_box .count_btn {
		margin-top: 0.5rem;
		padding-top: 0.3rem;
		border-top: 1px solid #f8f8f8;
		color: #333333;
	}

	.step_box {
		position: relative;
		padding: 0.32rem 0.32rem 0 0.32rem;
	}

	.step_box img {
		width: 100%;
		height: auto;
	}

	.step_box .step_el {
		position: relative;
	}

	.step_box .step_el:last-child {
		padding-bottom: 0;
	}

	.step_box .step_el .tit {
		position: absolute;
		top: 0.32rem;
		left: 0.32rem;
		font-size: 0.533rem;
		color: #333333;
		font-weight: bold;
	}

	.note_el {
		position: relative;
		padding-bottom: 0.4rem;
		line-height: 1.4;
	}

	.note_el .title {
		font-weight: bold;
		color: #0073DE;
		font-style: italic;
	}

	.note_el .title_l {
		font-weight: bold;
		color: #000000;
	}

	.note_el .text a {
		font-weight: bold;
		color: #000000;
		font-style: italic;
	}


	.btn_box {
		/* 	position: fixed;
	bottom: 0.667rem;
	width: 100%; */
		padding: 0 0.9rem 0.667rem 0.9rem;
	}

	.btn_box img {
		width: 100%;
	}

	>>>.van-button {
		height: 1.2rem;
	}

	>>>.van-button__text {
		color: #ffffff;
		font-size: 0.48rem;
		font-weight: bold;
	}

	@media screen and (min-device-width : 768px) {
		.btn_box {
			position: relative;
			width: 100%;
			padding: 1rem 0.9rem 0.667 0.9rem;
		}
	}
</style>
